// extracted by mini-css-extract-plugin
export default {"loader":"UpcomingBookings_loader__ZUaLb","h1":"UpcomingBookings_h1__mjhx0","wishlist":"UpcomingBookings_wishlist__ygdja","wishlist1":"UpcomingBookings_wishlist1__3shxz"};